export function getCookieByName(name) {
  const cookieRows = document.cookie.split('; ');
  for (let i = 0; i < cookieRows.length; i++) {
    const row = cookieRows[i];
    if (row.startsWith(`${name}=`)) {
      return row.split('=')[1];
    }
  }
  return undefined;
}